import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=0a71a5bc"
import script from "./Status.vue?vue&type=script&lang=ts"
export * from "./Status.vue?vue&type=script&lang=ts"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./Status.vue?vue&type=style&index=0&id=0a71a5bc&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-intelligent-match/mfe-intelligent-match/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a71a5bc')) {
      api.createRecord('0a71a5bc', component.options)
    } else {
      api.reload('0a71a5bc', component.options)
    }
    module.hot.accept("./Status.vue?vue&type=template&id=0a71a5bc", function () {
      api.rerender('0a71a5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Status.vue"
export default component.exports